/// <reference types="vite/client" />
// Mostly same as https://github.com/ElMassimo/stimulus-vite-helpers/blob/main/src/index.ts
// We've modified the regex to also match xx_component_controller.js instead of the traditional xx_controller.js for our view components
import {
  Application,
  defaultSchema,
  ControllerConstructor,
  Definition,
} from '@hotwired/stimulus'

type ImportedModules = Record<string, { default?: ControllerConstructor }>
type Entry<T> = { [K in keyof T]: [K, T[K]] }[keyof T]

const customSchema = {
  ...defaultSchema,
  keyMappings: { ...defaultSchema.keyMappings, backspace: 'Backspace' },
}

const application = Application.start(document.documentElement, customSchema)

const CONTROLLER_FILENAME_REGEX =
  /^(?:.*?(?:controllers|components)\/|\.?\.\/)?(.+?)(?:(?:[_-]component)?[_-]controller\..+?)$/

function registerControllers(
  application: Application,
  controllerModules: ImportedModules
) {
  application.load(definitionsFromGlob(controllerModules))
}

function definitionsFromGlob(controllerModules: ImportedModules) {
  return Object.entries(controllerModules)
    .map(definitionFromEntry)
    .filter((value) => value) as Definition[]
}

function definitionFromEntry([name, controllerModule]: Entry<ImportedModules>) {
  const identifier = identifierForGlobKey(name)
  const controllerConstructor = controllerModule.default
  if (identifier && typeof controllerConstructor === 'function')
    return { identifier, controllerConstructor }
  return
}

function identifierForGlobKey(key: string) {
  const logicalName = (key.match(CONTROLLER_FILENAME_REGEX) || [])[1]
  if (logicalName) return logicalName.replace(/_/g, '-').replace(/\//g, '--')
  return
}
const controllers = import.meta.glob(
  ['./**/*_controller.js', '../../components/**/*_controller.js'],
  {
    eager: true,
  }
) as ImportedModules
registerControllers(application, controllers)
